import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { LookupService } from 'src/app/Services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { SalService } from 'src/app/Services/sal/sal.service';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SaleorderviewmodelComponent } from '../saleorderviewmodel/saleorderviewmodel.component';
import { ConfirmationDialogService } from 'src/app/services/sal/confirmation-dialog.service';
import * as moment from 'moment';
import { InvoiceviewmodelComponent } from '../invoiceviewmodel/invoiceviewmodel.component';

@Component({
  selector: 'app-payout-pay',
  templateUrl: './payout-pay.component.html',
  styleUrls: ['./payout-pay.component.css']
})
export class PayoutPayComponent implements OnInit {

  @ViewChild('fileUploader', { static: false }) fileUploader: ElementRef;

  Submitted: boolean = false;
  Action: any = "Add";
  ReceiptNo = '';
  TotalAmount: any;
  DateRange='';
  constructor(private modalService: NgbModal, private confirmationDialogService: ConfirmationDialogService,
    private router: Router, private salservice: SalService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) {
  }


  SearchModel = {
    PartnerID: 0,
    ToDate: moment(Date.now()).format("DD-MMM-YYYY"),
    FromDate: moment(new Date().getTime() - (30 * 24 * 60 * 60 * 1000)).format("DD-MMM-YYYY"),
  };

  ClearSearch() {
    this.SearchModel.PartnerID = 0;
    this.SearchModel.FromDate = moment(new Date().getTime() - (30 * 24 * 60 * 60 * 1000)).format("DD-MMM-YYYY");
    this.SearchModel.ToDate = moment(Date.now()).format("DD-MMM-YYYY");
    this.SaleOrderList = [];
    this.Submitted=false;
    this.DateRange='';
  }

  ClearList(){
    this.SaleOrderList = [];
    this.GetTotalPaidAmount();
  }
  SaleOrderList = [];
  GetAllPayout() {
    this.PayoutModel.ReferenceNo = '';
    this.PayoutModel.PaymentModeID = 0;
    this.PayoutModel.Remarks = '';
    this.PayoutModel.DeductionAmount=0;
    this.spinnerService.show();
    this.SearchModel.FromDate = this.SearchModel.FromDate != null && this.SearchModel.FromDate != '' ? moment(this.SearchModel.FromDate).format('DD-MMM-YYYY') : '';
    this.SearchModel.ToDate = this.SearchModel.ToDate != null && this.SearchModel.ToDate != '' ? moment(this.SearchModel.ToDate).format('DD-MMM-YYYY') : '';

    this.salservice.GetAllPayout(JSON.stringify(this.SearchModel)).subscribe((response: any) => {
      this.SaleOrderList = response.SaleOrderList;
      var TotalAmount = 0;
      var TotalPayout = 0;
      if (this.SaleOrderList != null) {
        for (var i = 0; i < this.SaleOrderList.length; i++) {
          TotalAmount = TotalAmount + this.SaleOrderList[i].Amount;
          TotalPayout = TotalPayout + this.SaleOrderList[i].CreditAmount;
        }
      }
      this.TotalAmount = TotalAmount;
      this.PayoutModel.Amount = TotalPayout;
      this.GetTotalPaidAmount();
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(response);
    });
  };

  // Payout

  PayoutModel = {
    PartnerID: 0,
    ReferenceNo: '',
    Amount: 0,
    DeductionAmount: 0,
    PaidAmount: 0,
    Remarks: '',
    PaymentModeID: 0,
    ChequeNo:'',
  }

  GetTotalPaidAmount() {
    this.PayoutModel.PaidAmount = this.PayoutModel.Amount - this.PayoutModel.DeductionAmount;
  }

  ValidityPay() {
    return this.SearchModel.PartnerID == 0||this.PayoutModel.PaymentModeID==0||this.PayoutModel.ReferenceNo=='' ;
  }

  SelectedFileForUpload: any;
  selectFileforUpload(file) {
    this.SelectedFileForUpload = file[0];
  };

  SavePayout() {
    this.Submitted=true;
    this.ItemList=[];
    if (!this.ValidityPay()) {
      if(Math.floor((new Date(this.SearchModel.ToDate).getTime() - new Date(this.SearchModel.FromDate).getTime()) / 1000 / 60 / 60 / 24)>30){
        this.DateRange='Please select One month range';
        return;
      }
      this.PayoutModel.PartnerID=this.SearchModel.PartnerID;
      for(var i=0;i<this.SaleOrderList.length;i++){
        var Item={
          'SaleOrderPackageID':this.SaleOrderList[i].SaleOrderPackageID,
          'Amount':this.SaleOrderList[i].Amount
        }
        this.ItemList.push(Item)
      }
      this.Submitted=false;     
      this.spinnerService.show();
      this.salservice.SavePayout(JSON.stringify(this.PayoutModel),JSON.stringify(this.ItemList),this.SelectedFileForUpload).subscribe((response: any) => {
        this.ReceiptNo = response.ReceiptNo;
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(response);
      });
    }
  }

  Reset() {
    this.ReceiptNo='';
    this.PayoutModel.ReferenceNo = '';
    this.PayoutModel.PaymentModeID = 0;
    this.PayoutModel.Remarks = '';
    this.PayoutModel.DeductionAmount=0;
    if(this.SelectedFileForUpload!=null)
    this.fileUploader.nativeElement.value = null;
    this.GetAllPayout();
  }


  ngOnInit() {
    this.GetAllPartner();
    this.GetPaymentMode();
  }
  PaymentModeList=[];
  GetPaymentMode() {
    this.lookupservice.GetLookupsList('PaymentMode', '').subscribe((data: any) => {
      this.PaymentModeList = data.LookupItems;
    });
  };

  PartnerList: any;
  GetAllPartner() {
    this.lookupservice.GetLookupsList('Partner', '').subscribe((data: any) => {
      this.PartnerList = data.LookupItems;

    });
  };


  // View Invoice
  InvoiceDetails: any;
  ViewInvoice(item) {

    this.InvoiceDetails = item;

    const modalRef = this.modalService.open(InvoiceviewmodelComponent, { size: 'xl' });
    modalRef.componentInstance.InvoiceDetails = this.InvoiceDetails;

    modalRef.result.then((result) => {
      if (result) {
        console.log(result);
      }
    });

  }
  PrintInvoice(item) {

    window.localStorage.setItem("PaymentDetails", JSON.stringify(item));
    var url = "printinvoice";
    this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
  };

  // View Sake Order

  ItemList: any;
  Details: any;
  SumTotalTax: any;
  OrderDetails: any;

  ViewSaleOrder(item) {

    this.OrderDetails = item;

    const modalRef = this.modalService.open(SaleorderviewmodelComponent, { size: 'xl' });
    modalRef.componentInstance.OrderDetails = this.OrderDetails;

    modalRef.result.then((result) => {
      if (result) {
        console.log(result);
      }
    });

  }

}



